import { useWebSocket } from '@hooks/useWebSocket';
import useAppInitStore from '@store/AppInitStore';
import useApplyingSchoolsPlannerStore from '@store/ApplyingSchoolsPlannerStore';

const APPLYING_COLLEGES_UPDATED = 'APPLYING_COLLEGES_UPDATED';

export const useApplyingCollegesSync = () => {
  const isInitialized = useAppInitStore((state) => state.isInitialized);

  useWebSocket({
    enabled: isInitialized,
    onMessage: (message) => {
      if (message.type !== APPLYING_COLLEGES_UPDATED) return;

      void useApplyingSchoolsPlannerStore
        .getState()
        .getAppliedSchool()
        .catch((error: unknown) => {
          console.error('Failed to refresh applying schools after a WebSocket update', { error });
        });
    },
  });
};
